/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");
const html = document.querySelector("html");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

document.documentElement.className += "ontouchstart" in document.documentElement ? " touch" : " no-touch";

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".faqs__item");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".faqs__item").classList.toggle("faqs__item--open");
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink:not(.sociallink--email)");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
  GENERAL - Companies Tabs
========================================================================== */
const companiesTabsInit = function () {
  const tabContainer = document.querySelector(".companies-filters");

  if (tabContainer != null) {
    const tabButtons = tabContainer.querySelectorAll('[role="tab"]');
    const tabPanels = Array.from(tabContainer.querySelectorAll('[role="tabpanel"]'));

    tabButtons.forEach(button => {
      button.addEventListener("click", function (e) {
        // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);

        //Hide All Tabpane
        tabPanels.forEach(panel => {
          panel.hidden = "true";
        });

        //Deselect Tab Button
        tabButtons.forEach(button => {
          button.setAttribute("aria-selected", "false");
        });

        //Mark New Tab
        e.currentTarget.setAttribute("aria-selected", "true");

        //Show New Tab
        const { id } = e.currentTarget;

        const currentTab = tabPanels.find(panel => panel.getAttribute("aria-labelledby") === id);

        currentTab.hidden = false;
      });
    });
  }
};
companiesTabsInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects, window);
        Waypoint.refreshAll();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
    statistics count up
    ========================================================================== */

/*  ==========================================================================
    statistics count up
    ========================================================================== */

const statsModules = document.querySelectorAll(".statistic__heading:not(.placeholder) .statistic__heading__value");

const statInit = function (statsModules, context) {
  if (statsModules.length) {
    statsModules.forEach(val => {
      let startVal = val.dataset.start;
      var animation = new countUp.CountUp(val, val.innerHTML, {
        startVal: startVal,
        separator: ""
      });
      animation.start();
    });
  }
}; // statInit()
statInit(statsModules);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel:not(.companies-carousel)");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      smartSpeed: 500,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
			Case Studies Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const companyCarousels = document.querySelectorAll(".row--carousel .companies-carousel");

const companyCarouselsInit = function (companyCarousels) {
  if (companyCarousels.length <= 0) {
    return;
  }

  companyCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplaytimeout ? elem.dataset.autoplaytimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      startPosition: slides.length,
      autoHeight: autoHeight,
      smartSpeed: 1200,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      slideBy: "3",
      rewindNav: true,
      lazyLoad: true,
      rewindSpeed: 0,
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
          mouseDrag: true,
          touchDrag: true,
          pullDrag: true
        },
        // breakpoint from 480 up
        700: {
          items: 4,
          mouseDrag: false,
          touchDrag: false,
          pullDrag: false
        },
        // breakpoint from 768 up
        1000: {
          items: 5,
          mouseDrag: false,
          touchDrag: false,
          pullDrag: false
        }
      },
      onInitialized: function () {
        Waypoint.refreshAll();
      }
    });

    $(elem).on("changed.owl.carousel", function (event) {
      $(elem).trigger("stop.owl.autoplay");
      $(elem).trigger("play.owl.autoplay", [7000]);
      setTimeout(function () {
        Waypoint.refreshAll();
        lazyLoadInstance.update();
      }, 500);
    });
  });
}; // companyCarouselsInit();
companyCarouselsInit(companyCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnavToggle = document.querySelector(".mobnav-toggle");
const closeButton = document.querySelector(".sitenav__close");
const overlay = document.querySelector(".overlay");

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    mobnavToggle.classList.toggle("active");
    body.classList.toggle("sidenav-open");
    html.classList.toggle("sidenav-open");
    overlay.classList.toggle("active");
  });

  closeButton.addEventListener("click", function (e) {
    e.preventDefault();
    mobnavToggle.classList.remove("active");
    body.classList.remove("sidenav-open");
    setTimeout(function () {
      html.classList.remove("sidenav-open");
    }, 500);
    overlay.classList.remove("active");
  });

  overlay.addEventListener("click", function (e) {
    e.preventDefault();
    mobnavToggle.classList.remove("active");
    body.classList.remove("sidenav-open");
    setTimeout(function () {
      html.classList.remove("sidenav-open");
    }, 500);
    overlay.classList.remove("active");
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
    GENERAL - Filters Dropdown
  ========================================================================== */

const filtersInit = function () {
  const filtersToggle = document.querySelector(".filters__toggle");
  const filtersDropdown = document.querySelector(".filters__dropdown");

  if (!filtersToggle) {
    return;
  }

  filtersToggle.addEventListener("click", function (e) {
    filtersToggle.classList.toggle("active");
    filtersDropdown.classList.toggle("active");
    Waypoint.refreshAll();
  });
}; //filtersInit();
filtersInit();

/*  ==========================================================================
    FILTERS - Posts Filtering
    ========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchInput = document.querySelector(".filters__search__input input");
const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;
if (typeof filters !== "undefined" && filters !== null) {
  // Get current from filters data
  /* jshint ignore:start */

  const filterGetFormData = function () {
    let filter_data = {};

    filter_settings.filters.forEach(function (el) {
      let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
      filter_data[el.name] = [...checkedOptions].map(x => x.value);
    });

    return filter_data;
  };

  const filterUpdateURL = function (filterData, searchData) {
    let url_params = "";

    for (const [key, value] of Object.entries(filterData)) {
      if (value.length > 0) {
        if (url_params === "") {
          url_params = url_params + "?";
        } else {
          url_params = url_params + "&";
        }
        // Convert values to comma seperated string
        let values = Object.keys(value)
          .map(function (k) {
            return value[k];
          })
          .join(",");

        if (values !== "") {
          url_params = url_params + "filter_" + key + "=" + values;
        } else {
          url_params = "";
        }
      }
    }

    if (searchData) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      url_params = url_params + "search=" + searchData;
    }

    let currentPageUrl = window.location.href.split("?")[0];
    currentPageUrl = currentPageUrl.split("page")[0];

    let newUrl = currentPageUrl + url_params;

    if (url_params !== "") {
      history.pushState({}, "", newUrl);
    }

    if (history.pushState) {
      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  };

  // Toggles All Content checkbox if there is selected filters within the group
  const filterSelectedAllCheckboxes = function (groupName) {
    let noActiveFiltersInGroup = true;

    document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
      if (el.checked === true) {
        noActiveFiltersInGroup = false;
      }
    });
    const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
    if (allGroupCheckbox) {
      allGroupCheckbox.checked = noActiveFiltersInGroup;
    }
  };

  if (filterSearchInput) {
    filterSearchInput.addEventListener("focus", event => {
      event.target.nextElementSibling.style.opacity = "0";
    });

    filterSearchInput.addEventListener("focusout", event => {
      if (
        filterSearchInput.value == "" ||
        filterSearchInput.value == " " ||
        filterSearchInput.value == undefined ||
        filterSearchInput.value == null
      ) {
        event.target.nextElementSibling.style.opacity = "1";
      }
    });
  }

  // Setup up the active tags in the filter bar
  const filterAddingActiveTags = function (filterData) {
    let hasClassActive = false;
    // Reset styles
    const fieldsets = document.querySelectorAll(".filters__fieldset");
    fieldsets.forEach(set => {
      set.classList.remove("filters__fieldset--active");
    });

    const fieldsetField = document.querySelectorAll(".filters__fieldset__field--categories");
    fieldsetField.forEach(field => {
      field.classList.remove("filters__fieldset__field--active");
    });

    const fieldsetFieldTypes = document.querySelectorAll(".filters__fieldset__field--type");
    fieldsetFieldTypes.forEach(field => {
      field.classList.remove("filters__fieldset__field--active");
    });

    for (const [key, values] of Object.entries(filterData)) {
      if (values.length > 0) {
        // Make field group active
        document
          .querySelector(".filters__fieldset[data-value='" + key + "']")
          .classList.remove("filters__fieldset--active");

        for (const value of values) {
          // Make input field active

          let filter_input = document
            .querySelector("input[name='" + key + "'][value='" + value + "']")
            .closest(".filters__fieldset__field");

          filter_input.classList.add("filters__fieldset__field--active");

          hasClassActive = true;
        }
      }

      filterSelectedAllCheckboxes(key);
    }

    return hasClassActive;
  };

  const filterGetPosts = function (updateURL = false) {
    // Getting the forma data
    let filterData = filterGetFormData();
    let searchData = filterSearchInput.value;

    if (filterData || searchData) {
      // Update url
      if (updateURL) {
        filterUpdateURL(filterData, searchData);
      }

      let activeTagsNotEmpty = filterAddingActiveTags(filterData);

      if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
        filtersInitialLoad = false;

        // get site padder header height
        let siteheaderpadder = document.querySelector(".pageheader--page");
        let siteheaderpadderHeight = siteheaderpadder.offsetHeight;

        // get teams filter height
        let portFilter = document.querySelector(".filters");
        let portFilterHeight = portFilter.offsetHeight;

        let filterPin = document.querySelector(".filters__pin");

        const filterPinRec = filterPin.getBoundingClientRect();

        const top = window.scrollY + filterPinRec.top - siteheaderpadderHeight;

        window.scrollTo({
          top: top,
          behavior: "smooth"
        });

        // If there's an active search, open the search field
        if (searchData) {
          document.querySelector(".filters__search").classList.add("filters__search--open");
        }

        // Start filtering
        document.querySelector(".posts.loadmore-container").classList.add("filtering");

        let page_url = window.location.href;

        // Trigger ajax
        let data = {
          action: "filter",
          query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
          page: php_variables.current_page,
          filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
          filter_data: filterData,
          search_data: searchData,
          page_url: page_url
        };

        $.ajax({
          url: php_variables.ajax_url,
          data: data, // form data
          dataType: "json", // this data type allows us to receive objects from the server
          type: "POST",
          success: function (data) {
            // when filter applied:
            // set the current page to 1
            php_variables.current_page = 1;

            // set the new query parameters
            php_variables.posts = data.posts;

            // set the new max page parameter
            php_variables.max_page = data.max_page;

            // hide load more button, if there are not enough posts for the second page

            const paginationContainer = document.querySelector(".pagination__numbers");
            if (paginationContainer) {
              paginationContainer.innerHTML = data.navigation;
            }

            // insert the posts to the container
            const loadmoreContainer = document.querySelector(".posts.loadmore-container");
            if (loadmoreContainer) {
              loadmoreContainer.innerHTML = data.content;
              // Finish filtering
              loadmoreContainer.classList.remove("filtering");
            }

            setFilterTagsListeners();

            lazyLoadInstance.update();

            const effects = document.querySelectorAll(".effect");

            effectsInit(effects, window);
          },
          error: function (data) {}
        });
      }
    }
  };

  const setFilterTagsListeners = function () {
    const allFilterTags = document.querySelectorAll(".filters__tag");
    allFilterTags.forEach(tag => {
      tag.addEventListener("click", function () {
        let filter_name = tag.dataset.name;
        let filter_value = tag.dataset.value;
        let filter_input = (document.querySelector(
          "input[name='" + filter_name + "'][value='" + filter_value + "']"
        ).checked = false);
        // Remove tag
        tag.remove();
        // Trigger filter
        filterGetPosts();
      });
    });
  };

  const filterSetupClearAll = function () {
    const filterClearAll = document.querySelectorAll(".filters__clearall");
    const filterClearCategories = document.querySelector(".filters__fieldset__field--all");

    const filterClearAllTypes = document.querySelectorAll(".filters__fieldset__field--clear");

    filterClearAll.forEach(btn => {
      btn.addEventListener("click", function () {
        // Uncheck all inputs
        const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field--categories input");
        filterCheckboxes.forEach(el => (el.checked = false));

        // Trigger filter
        filterGetPosts(true);

        filterClearCategories.classList.add("filters__fieldset__field--active");
      });
    });

    filterClearCategories.addEventListener("click", function () {
      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field--categories input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts(true);

      filterClearCategories.classList.add("filters__fieldset__field--active");
    });

    filterClearAllTypes.forEach(btn => {
      btn.addEventListener("click", function () {
        // Uncheck all inputs
        const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field--type input");
        filterCheckboxes.forEach(el => (el.checked = false));

        // Trigger filter
        filterGetPosts(true);

        btn.classList.add("filters__fieldset__field--active");
      });
    });
  };

  // Init Filter on posts pages
  const filterInit = function () {
    let currentPageUrl = window.location.href.split("?")[0];

    const submitBtn = document.querySelector(".filters__apply");
    const filterForm = document.querySelector(".filters__form");

    if (filterForm && filterForm.length) {
      // Get Posts based on Filter Form Data
      filterGetPosts(false);

      // Dropdown open & close
      filtersToggle.addEventListener("click", function (e) {
        e.stopPropagation();
        filters.classList.remove("filters--searchopen");
        filters.classList.toggle("filters--dropdownopen");
      });

      // Filter on submit
      filterForm.addEventListener("submit", function (e) {
        // Stop the form from submitting
        e.preventDefault();

        // Call the filtering post function
        filterGetPosts(true);
        filters.classList.remove("filters--searchopen");
        filters.classList.remove("filters--dropdownopen");
      });

      const filterCheckboxesCategories = filterForm.querySelectorAll(".filters__fieldset__field--categories input");
      const filterClearCategories = document.querySelector(".filters__fieldset__field--all");

      const filterCheckboxesType = filterForm.querySelectorAll(".filters__fieldset__field--type input");
      const filterClearTypes = document.querySelector(".filters__fieldset__field--clear");

      filterCheckboxesCategories.forEach(checkbox => {
        checkbox.addEventListener("change", function (evt) {
          // Submit for on checkbox click
          php_variables.current_page = 1;
          filterGetPosts(true);
          filters.classList.toggle("filters--dropdownopen");
          // Remove active class
          if (checkbox.classList.contains("all")) {
            filterClearCategories.classList.add("active");
            filterClearCategories.classList.add("filters__fieldset__field--active");
          } else {
            filterClearCategories.classList.remove("active");
            filterClearCategories.classList.remove("filters__fieldset__field--active");
          }
        });
      });

      filterCheckboxesType.forEach(checkbox => {
        checkbox.addEventListener("change", function (evt) {
          // Submit for on checkbox click
          php_variables.current_page = 1;
          filterGetPosts(true);
          filters.classList.toggle("filters--dropdownopen");
          // Remove active class
          if (checkbox.classList.contains("all")) {
            filterClearTypes.classList.add("active");
            filterClearTypes.classList.add("filters__fieldset__field--active");
          } else {
            filterClearTypes.classList.remove("active");
            filterClearTypes.classList.remove("filters__fieldset__field--active");
          }
        });
      });

      // Remove tags on click
      setFilterTagsListeners();

      // Clear all
      filterSetupClearAll();
    }
  };
  filterInit();
}

/*  ==========================================================================
    FILTERS - All Companies Listing
    ========================================================================== */
var containerEl = document.querySelector(".container");
var targetSelector = ".mix";
var activeHash = "";
var activePage = -1;
var allButton = document.querySelector(".control--all");
var clearButton = document.querySelector(".filters__dropdown__clear");
var filterButtons = document.querySelectorAll(".control-sector ");

if (typeof containerEl !== "undefined" && containerEl !== null) {
  /**
   * Deserializes a hash segment (if present) into in an object.
   *
   * @return {object|null}
   */

  function deserializeHash() {
    var hash = window.location.hash.replace(/^#/g, "");
    var obj = null;
    var props = [];

    if (!hash) {
      return obj;
    }

    obj = {};
    props = hash.split("&");

    props.forEach(function (props) {
      var pair = props.split("=");
      var propName = pair[0];

      obj[propName] = propName === "page" ? parseInt(pair[1]) : pair[1].split(",");
    });

    return obj;
  }

  /**
   * Serializes a uiState object into a string.
   *
   * @param   {object}    uiState
   * @return  {string}
   */

  function serializeUiState(uiState) {
    var output = "";

    for (var key in uiState) {
      var values = uiState[key];

      if (Array.isArray(values) && !values.length) {
        continue;
      }

      output += key + "=";
      output += Array.isArray(values) ? values.join(",") : values;
      output += "&";
    }

    output = output.replace(/&$/g, "");

    return output;
  }

  /**
   * Constructs a `uiState` object using the
   * `getFilterGroupSelectors()` API method.
   *
   * @return {object}
   */

  function getUiState() {
    var page = mixer.getState().activePagination.page;

    // NB: You will need to rename the following keys to match the names of
    // your project's filter groups – these should match those defined
    // in your HTML.

    var uiState = {
      sector: mixer.getFilterGroupSelectors("sector").map(getValueFromSelector)
    };

    if (page > 1) {
      uiState.page = page;
    }

    return uiState;
  }

  /**
   * Updates the URL hash whenever the current UI state changes.
   *
   * @param   {mixitup.State} state
   * @return  {void}
   */

  function setHash(state) {
    var selector = state.activeFilter.selector;

    // Construct an object representing the current state of each
    // filter group

    var uiState = getUiState();
    var page = uiState.page || 1;

    // Create a URL hash string by serializing the uiState object

    var newHash = "#" + serializeUiState(uiState);

    if (selector === targetSelector && window.location.href.indexOf("#") > -1 && page === 1) {
      // Equivalent to filter "all", and a hash exists, remove the hash

      activeHash = "";

      history.replaceState(null, document.title, window.location.pathname);
    } else if ((newHash !== window.location.hash && selector !== targetSelector) || page > 1) {
      // Change the hash

      activeHash = newHash;

      history.replaceState(null, document.title, window.location.pathname + newHash);
    }
    setTimeout(function () {
      allButton.classList.remove("mixitup-control-actives");
    }, 1000);
  }

  /**
   * Updates the mixer to a previous UI state.
   *
   * @param  {object|null}    uiState
   * @param  {boolean}        [animate]
   * @return {Promise}
   */

  function syncMixerWithPreviousUiState(uiState, animate) {
    var sector = uiState && uiState.sector ? uiState.sector : [];

    activePage = uiState && uiState.page ? uiState.page : 1;

    mixer.setFilterGroupSelectors("sector", sector.map(getSelectorFromValue));

    // Parse the filter groups (passing `false` will perform no animation)

    return mixer.parseFilterGroups(animate ? true : false);
  }

  /**
   * Converts a selector (e.g. '.green') into a simple value (e.g. 'green').
   *
   * @param   {string} selector
   * @return  {string}
   */

  function getValueFromSelector(selector) {
    return selector.replace(/^./, "");
  }

  /**
   * Converts a simple value (e.g. 'green') into a selector (e.g. '.green').
   *
   * @param   {string} selector
   * @return  {string}
   */

  function getSelectorFromValue(value) {
    return "." + value;
  }

  /**
   * A function for filtering the values of the mixitup command object
   * generated by calling the `parseFilterGroups()` method.
   *
   * @param  {object} command
   * @return {object}
   */

  function handleParseFilterGroups(command) {
    if (activePage > 1) {
      // If an activePage greater than 1 has been parsed
      // from the URL, update the command with a pagination
      // instruction

      command.paginate = activePage;
    }

    return command;
  }

  var uiState = deserializeHash();

  // Instantiate MixItUp

  var mixer = mixitup(containerEl, {
    multifilter: {
      enable: true
    },
    pagination: {
      limit: 12,
      maintainActivePage: false
    },
    animation: {
      effects: "fade translateZ(-100px)"
    },
    callbacks: {
      onParseFilterGroups: handleParseFilterGroups,
      onMixEnd: setHash // Call the setHash() method at the end of each operation
    }
  });

  if (uiState) {
    // If a valid uiState object is present on page load, filter the mixer

    syncMixerWithPreviousUiState(uiState);
  }
  /* jshint ignore:end */

  filterButtons.forEach(filterButton => {
    filterButton.addEventListener("click", function () {
      allButton.classList.remove("mixitup-control-active");
      console.log(window.location.hash);
    });
  });

  clearButton.addEventListener("click", function () {
    allButton.classList.add("mixitup-control-active");
  });

  allButton.addEventListener("click", function () {
    allButton.classList.add("mixitup-control-active");
  });

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      if (window.location.hash) {
        allButton.classList.remove("mixitup-control-active");
      }
    },
    false
  );
}
